import {NinchatProperties} from 'api/types'
import {assignTranscript} from 'api/action/assignTranscript'
import {createComment} from 'api/action/createComment'
import {toast} from 'components/Toast'
import {useAppDispatch} from 'hooks'
import {useTranslation} from 'react-i18next'

export const useUnassignTranscript = () => {
    const dispatch = useAppDispatch()
    const {t} = useTranslation()

    const unassignTranscript = async (audienceId: NinchatProperties.AudienceID, unassignUserId: NinchatProperties.UserID, reason: string) => {
        try {
            await dispatch(createComment({
                audience_id: audienceId,
                comment_text: reason,
            })).unwrap()
        } catch {
            toast.error(t('Error adding comment'))
            return
        }

        try {
            await dispatch(assignTranscript({
                audience_id: audienceId,
                unassign_user_id: unassignUserId,
            })).unwrap()
        } catch {
            toast.error(t('Error unassigning'))
            return
        }

        toast.success(t('Unassigned'))
    }

    return {unassignTranscript}
}
